module.exports = __webpack_public_path__ + "img/1-6.c3b5a384.png";